import appsClinicianActive from './dashboard-active'

export default [...appsClinicianActive]